import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivitySummary = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'article_created':
        return 'FileText';
      case 'fact_check':
        return 'CheckCircle';
      case 'bias_detection':
        return 'Search';
      case 'profile_updated':
        return 'Settings';
      case 'login':
        return 'LogIn';
      default:
        return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'article_created':
        return 'text-primary';
      case 'fact_check':
        return 'text-success';
      case 'bias_detection':
        return 'text-warning';
      case 'profile_updated':
        return 'text-secondary';
      case 'login':
        return 'text-accent';
      default:
        return 'text-muted-foreground';
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp);
    const diffInMinutes = Math.floor((now - activityTime) / (1000 * 60));

    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours}h ago`;
    
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) return `${diffInDays}d ago`;
    
    return activityTime?.toLocaleDateString();
  };

  return (
    <div className="bg-card rounded-xl shadow-elevated border border-border p-6">
      <div className="flex items-center space-x-3 mb-6">
        <Icon name="Activity" size={24} color="var(--color-primary)" />
        <h2 className="text-xl font-heading font-semibold text-foreground">
          Recent Activity
        </h2>
      </div>
      <div className="space-y-4">
        {activities?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Clock" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4 opacity-50" />
            <p className="text-muted-foreground">No recent activity</p>
          </div>
        ) : (
          activities?.map((activity, index) => (
            <div key={index} className="flex items-start space-x-4 p-4 rounded-lg hover:bg-muted/50 transition-colors duration-250">
              <div className={`flex-shrink-0 w-10 h-10 rounded-full bg-muted flex items-center justify-center ${getActivityColor(activity?.type)}`}>
                <Icon name={getActivityIcon(activity?.type)} size={18} />
              </div>
              
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground">
                  {activity?.title}
                </p>
                <p className="text-sm text-muted-foreground mt-1">
                  {activity?.description}
                </p>
                <p className="text-xs text-muted-foreground mt-2">
                  {formatTimeAgo(activity?.timestamp)}
                </p>
              </div>

              {activity?.status && (
                <div className="flex-shrink-0">
                  <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                    activity?.status === 'completed' 
                      ? 'bg-success/10 text-success' 
                      : activity?.status === 'pending' ?'bg-warning/10 text-warning' :'bg-error/10 text-error'
                  }`}>
                    {activity?.status}
                  </span>
                </div>
              )}
            </div>
          ))
        )}
      </div>
      {activities?.length > 0 && (
        <div className="mt-6 pt-4 border-t border-border">
          <button className="w-full text-center text-sm text-primary hover:text-primary/80 transition-colors duration-250">
            View All Activity
          </button>
        </div>
      )}
    </div>
  );
};

export default ActivitySummary;